// extracted by mini-css-extract-plugin
export default {"drawer":"I42vIf6_ykZiAmiJlQ8t3"};